import React, { useState } from 'react'
import Header from './components/Header/Header';
import { Navigate } from 'react-router-dom';
import Sidebar from './components/SideBar/Sidebar';

const Layout = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [sideBar, setSideBar] = useState(false);
    const login = true;

    if (!login) {
        return <Navigate to="/login" />
    }

    return (
        <>
            <Header sideBar={sideBar} setSideBar={setSideBar} />
            <div className='d-flex'>
            <Sidebar sideBar={sideBar} setSideBar={setSideBar} />
            <div className={sideBar ? "mainbody sideactive" : "mainbody"}>
                {children}
            </div>
            </div>
        </>
    )
}

export default Layout
